import { render, staticRenderFns } from "./Medal.vue?vue&type=template&id=5b66213a&"
import script from "./Medal.vue?vue&type=script&lang=js&"
export * from "./Medal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports